import React from 'react';
import {CircularProgress, Stack, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router';
import {usePIRList} from '../../../../../firebase/firestore/usePIRList';

const PirList = () => {
    const {irId} = useParams();
    const navigate = useNavigate();
    const {data: pirs, loading, error} = usePIRList(irId);

    if (loading) return <Stack p={2}><CircularProgress/></Stack>;
    if (error) return <Stack p={2}><Typography color="error">Error loading
        PIRs: {String(error?.message || error)}</Typography></Stack>;
    if (!pirs || pirs.length === 0) return <Stack p={2}><Typography>No PIRs found.</Typography></Stack>;

    return (
        <Stack spacing={2}>
            {pirs.map(p => (
                <Stack
                    key={p.id}
                    p={2}
                    spacing={1}
                    border="1px solid #ddd"
                    bgcolor={'white'}
                    borderRadius={2}
                    onClick={() => navigate(`/PIR/${p.id}`)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') navigate(`/PIR/${p.id}`);
                    }}
                    sx={{
                        cursor: 'pointer',
                        '&:hover': {borderColor: 'black'}
                    }}
                >
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
                        <Typography variant={'Body1'} fontWeight={600}>{p.mainQuestion}</Typography>
                        <Typography variant={'subtitle2'} color={'gray'}>ID: {p.id}</Typography>
                    </Stack>
                    <Typography variant="body1" color="text.secondary"
                                sx={{whiteSpace: 'pre-line'}}>Parent IR: {p.parent_ir}</Typography>
                    <Typography variant="body1" color="text.secondary"
                                sx={{whiteSpace: 'pre-line'}}>{p.description}</Typography>
                </Stack>
            ))}
        </Stack>
    );
};

export default PirList;